export enum StavIenu {
	POVOLEN = 'POVOLEN',
	SMAZAN = 'SMAZAN',
	NEOVEREN = 'NEOVEREN'
}
